import { boardblendApi } from "@/store/api";
import type { AccountBilling } from "@/types/billing";

type BillingInterval = NonNullable<AccountBilling["interval"]>;

export interface CreateBillingCheckoutArgs {
  interval: BillingInterval;
  returnTo?: string;
}

export interface SyncBillingArgs {
  returnTo?: string;
  sessionId: string;
}

export const billingApi = boardblendApi.injectEndpoints({
  endpoints: (build) => ({
    getAccountBilling: build.query<AccountBilling, void>({
      query: () => "account/billing",
      providesTags: ["Billing"],
    }),
    createBillingCheckout: build.mutation<
      { url: string },
      CreateBillingCheckoutArgs
    >({
      query: (body) => ({
        body,
        method: "POST",
        url: "billing/checkout",
      }),
    }),
    createBillingPortal: build.mutation<{ url: string }, void>({
      query: () => ({
        method: "POST",
        url: "billing/portal",
      }),
    }),
    syncBilling: build.mutation<{ returnTo: string }, SyncBillingArgs>({
      query: (body) => ({
        body,
        method: "POST",
        url: "billing/sync",
      }),
      invalidatesTags: (_result, error) => (error ? [] : ["Billing"]),
    }),
  }),
});

export const {
  useCreateBillingCheckoutMutation,
  useCreateBillingPortalMutation,
  useGetAccountBillingQuery,
  useSyncBillingMutation,
} = billingApi;
